import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const AnalyticsChart = ({ impressions }) => {
  const data = {
    labels: ['Displayed', 'Views', 'Clicks'],
    datasets: [
      {
        label: 'Impressions by Type',
        data: [
          impressions.reduce((sum, imp) => imp.type === 'displayed' ? sum + imp.count : sum, 0),
          impressions.reduce((sum, imp) => imp.type === 'views' ? sum + imp.count : sum, 0),
          impressions.reduce((sum, imp) => imp.type === 'clicks' ? sum + imp.count : sum, 0),
        ],
        backgroundColor: ['#007bff', '#28a745', '#dc3545'],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Impression Metrics by Type',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Count',
        },
      },
    },
  };

  return (
    <div className="analytics-chart">
      <Bar data={data} options={options} />
    </div>
  );
};

export default AnalyticsChart;